import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import { messages } from './messages';
import { ShipFromValidator } from './validator';
import { emptyArray } from 'ui-components/default-props/empty';
import { ShipFromLabel } from '../../../../fulfillment-planner/ship-from/label';
import { ShipFromDropdownRenderer } from '../../../../fulfillment-planner/ship-from/ship-from-dropdown-renderer';
import Global from '../../../../store/global-selectors';
import { warehouseId } from '../../constants';

const defaultShipFromId = '0';

export const ShipFromPresetOption = ({ onChange, data, selectedCarrierId = '' }) => {
  const intl = useIntl();
  const sellerShipFroms = useSelector(Global.selectSellerShipFroms) || emptyArray;

  const shipFromsWithDefault = useMemo(() => {
    const shipFroms = sellerShipFroms.map((shipFrom) => ({
      id: shipFrom.shipFromId,
      ...shipFrom,
    }));
    return [
      {
        id: defaultShipFromId,
        name: intl.formatMessage(messages.selectShipFromMessage),
      },
      ...shipFroms,
    ];
  }, [intl, sellerShipFroms]);
  const onShipFromChange = useCallback(
    (value) => {
      if (value === defaultShipFromId) return;
      onChange({ name: warehouseId, value });
    },
    [onChange],
  );

  const selectedShipFromId = data || defaultShipFromId;

  return (
    <ShipFromValidator selectedCarrierId={selectedCarrierId} selectedShipFromId={selectedShipFromId} shipFroms={shipFromsWithDefault}>
      {({ validation }) => (
        <>
          <Text textType={TextType.Label} value={<ShipFromLabel />} />
          <ShipFromDropdownRenderer
            onAddShipFromSuccess={noop}
            onChange={onShipFromChange}
            selectedShipFromId={selectedShipFromId}
            shipFroms={shipFromsWithDefault}
            validation={validation}
          />
        </>
      )}
    </ShipFromValidator>
  );
};

ShipFromPresetOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.string,
  selectedCarrierId: PropTypes.string,
};
